// biome-ignore lint/suspicious/noShadowRestrictedNames: Immutable.js Map/Set
import { Map } from 'immutable';
import simpleReducer from '../common/utils/simple-reducer.js';
import { CHANGE_FIELD, VALIDATE_FORM } from '../schema-form/action-types.js';
import { FORM_NAME } from './constants.js';

const getProviderData = (data) => data.filterNot((_v, k) => ['title', 'provider'].includes(k));

const emptyProvider = Map({
  destination: undefined,
  idKey: undefined,
  secretKey: undefined
});

const emptyMap = Map();

export const reducers = {
  [VALIDATE_FORM](state, { meta }) {
    if (meta.formName !== FORM_NAME) {
      return state;
    }

    const data = state.get('data');
    const ignoreSecretKeyMissing = data.get('_id') && !data.get('secretKey');
    return ignoreSecretKeyMissing ? state.removeIn(['errors', 'secretKey']) : state;
  },
  [CHANGE_FIELD](state, { payload, meta }, prevState) {
    const { path, formName } = meta;
    if (formName !== FORM_NAME || path[0] !== 'provider') {
      return state;
    }

    const oldProvider = prevState.getIn(['data', 'provider']);
    if (oldProvider) {
      const data = state.get('data');
      const newProvider = payload;
      const providersData = state.get('providersData', emptyMap);
      const updatedProvidersData = providersData.set(oldProvider, getProviderData(data));
      const newProviderData = updatedProvidersData.get(newProvider, emptyProvider);
      return state.merge({
        data: data.merge(newProviderData),
        providersData: updatedProvidersData
      });
    }

    return state;
  }
};

export default simpleReducer(emptyMap, reducers);
